<div class="administration-layout-component mat-app-background desktopVersion">
    <!-- Mat toolbar -->
    <mat-toolbar [ngClass]="{ active: menuDrawer.opened }" color="primary">
        <mat-toolbar-row class="mat-toolbar-container">
            <div class="mat-toolbar-menu">
                <div class="mat-toolbar-image-menu">
                    <div>
                        <a class="" href="#">
                            <img src="../../../../assets/img/LOGOS SEM+GENCAT OK 1_2.PNG" class="header-img" />
                        </a>
                    </div>
                </div>
                <!-- Options -->
                <div class="mat-toolbar-group version" (click)="showSorageQuota()">
                    {{ getAppVersion() }}
                </div>
            </div>
            <div class="mat-toolbar-platform-name">
                <div class="mat-toolbar-platform-name-element1">
                    <div class="mat-icon-menu-drawer">
                        <mat-icon (click)="menuDrawer.toggle(); toggleSearch(true)">{{ getIcon() }}</mat-icon>
                    </div>
                    <div class="mat-toolbar-divider">/</div>
                    <div class="mat-icon-search" (click)="toggleSearch()">
                        <mat-icon>{{ getIcon("search") }}</mat-icon>
                    </div>
                </div>
                <div class="mat-toolbar-platform-name-element2">
                    <div class="profile-group">
                        <!-- Profile image -->
                        <div *ngIf="isSomeoneLogged()">
                            <div class="user-profile__img">
                                <!-- <mat-icon>person</mat-icon> -->
                                {{ getUserName() }}
                            </div>
                            <div class="user-profile__name">
                                {{ this.userDetails?.login }}
                            </div>
                        </div>
                        <div *ngIf="isSomeoneLogged()" style="margin-right: 8px">|</div>
                        <!-- User data -->
                        <div *ngIf="isSomeoneLogged()" class="user-profile-data">
                            <div style="font-weight: bolder; margin-right: 1em" class="user-profile__view">
                                {{ getFormattedDate() }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <!-- Search sections -->
    <div class="search-container" [ngClass]="{ active: showSearch }">
        <form [formGroup]="searchForm">
            <mat-form-field appearance="outline" class="search-input">
                <input
                    id="search-input"
                    formControlName="query"
                    matInput
                    [placeholder]="labels.search | translate"
                    (keyup.enter)="searchAction()"
                />
                <mat-icon matSuffix *ngIf="!searching" (click)="searchAction()" class="pointer">search</mat-icon>
                <mat-spinner matSuffix class="spinner" *ngIf="searching" diameter="20"></mat-spinner>
            </mat-form-field>
            <mat-checkbox formControlName="searchInPath" *ngIf="searchInPath"
                >{{ labels.searchOnlyIn | translate : { path: searchInPath } }}
            </mat-checkbox>
        </form>
        <div class="search-results" *ngIf="showSearch && getSearchGroups().length">
            <mat-accordion multi>
                <mat-expansion-panel expanded="true" *ngFor="let group of getSearchGroups()">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ getViewTitle(group) }} ({{ labels.numResults | translate : { num: searchResult[group].length } }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="result" *ngFor="let content of searchResult[group]" (click)="goToViewContent(content, group)" [ngClass]="{ esb: isEsbContent(content.estat) }">
                        {{ content.titol }}
                        <span *ngIf="url === 'farmacs' && content.hrm">
                            <img src="../../../../assets/img/warning-icon.svg" />
                        </span>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="search-results" *ngIf="showSearch && searchResult && !getSearchGroups().length">
            <b class="search-results__no-results">{{ labels.noResults | translate }}</b>
        </div>
    </div>

    <!-- Sidenav menu -->
    <mat-drawer-container
        id="mainContent"
        class="administration-container"
        autosize
        [hasBackdrop]="true"
        [ngClass]="{ active: menuDrawer.opened }"
    >
        <mat-drawer #menuDrawer class="left-sidenav-panel" [mode]="'over'" [opened]="false">
            <!-- Administration menu -->
            <ul class="left-menu">
                <li
                    class="left-menu-option home-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="INTRO_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    {{ labels.introduction | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="HNT_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="hnt-icon menu-sem-icon bigger">hnt</mat-icon> {{ labels.hnt | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="CECOS_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <!-- <mat-icon>health_and_safety</mat-icon> -->
                    <mat-icon fontSet="jenga" class="cecos-icon menu-sem-icon">cecos</mat-icon> CECOS
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="SVB_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <!-- <mat-icon>heart_broken</mat-icon> -->
                    <mat-icon fontSet="jenga" class="usvb-icon menu-sem-icon">usvb</mat-icon> USVB
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="SVA_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <!-- <mat-icon>monitor_heart</mat-icon> -->
                    <mat-icon fontSet="jenga" class="usva-icon menu-sem-icon">usva</mat-icon> USVA
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="PROCEDURES_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="procediments-icon menu-sem-icon">procediments</mat-icon>
                    {{ labels.procedures | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="CODIS_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="codis-icon menu-sem-icon">codis</mat-icon> {{ labels.codes | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="FARMACS_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <!-- <mat-icon>medication_liquid</mat-icon> -->
                    <mat-icon fontSet="jenga" class="farmacs-icon menu-sem-icon">farmacs</mat-icon>
                    {{ labels.farmacs | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="ESCALES_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <!-- <mat-icon>table_view</mat-icon> -->
                    <mat-icon fontSet="jenga" class="escales-icon menu-sem-icon">escales</mat-icon>
                    {{ labels.escales | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="GLOSS_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="gloss-icon menu-sem-icon">gloss</mat-icon>
                    {{ labels.glossary | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="PATHOPHYSIOLOGY_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="transport-icon menu-sem-icon bigger">transport</mat-icon>
                    {{ labels.pathophysiology | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="ETHIC_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="etica-icon menu-sem-icon">etica</mat-icon> {{ labels.ethic | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="MANUALS_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="electromedicina-icon menu-sem-icon">electromedicina</mat-icon> {{ labels.manuals | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="ABREVIACIONES_TEMPLATE_PATH"
                    routerLinkActive="active"
                >
                    <mat-icon fontSet="jenga" class="legal-icon menu-sem-icon">abreviaciones</mat-icon>
                    {{ labels.abreviaciones | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="USERS_TEMPLATE_PATH"
                    routerLinkActive="active"
                    *ngIf="isRoleAdmin()"
                >
                    <mat-icon fontSet="jenga" class="users-icon">users</mat-icon>
                    {{ labels.users | translate }}
                </li>
                <li
                    class="left-menu-option"
                    (click)="menuDrawer.toggle()"
                    [routerLink]="REPOSITORI_TEMPLATE_PATH"
                    routerLinkActive="active"
                    *ngIf="isAdministradorOrResponsable()"
                >
                    <mat-icon>insert_drive_file</mat-icon>
                    {{ labels.repositori | translate }}
                </li>
            </ul>
            <div class="left-sidenav-panel__bottom">
                <mat-divider></mat-divider>
                <ul class="left-menu">
                    <li
                        class="left-menu-option"
                        (click)="menuDrawer.toggle()"
                        [routerLink]="CONTACT_TEMPLATE_PATH"
                        routerLinkActive="active"
                    >
                        <mat-icon>mail_outline</mat-icon>
                        {{ labels.contact | translate }}
                    </li>
                    <li class="left-menu-option" *ngIf="!isSomeoneLogged()" (click)="goToLogin()">
                        <mat-icon>person_outline</mat-icon>
                        {{ labels.login | translate }}
                    </li>
                    <li class="left-menu-option" *ngIf="isSomeoneLogged()" (click)="closeSession()">
                        <mat-icon>exit_to_app</mat-icon>
                        {{ labels.signOut | translate }}
                    </li>
                </ul>
            </div>
        </mat-drawer>

        <!-- Administration render container -->
        <div class="left-sidenav-content">
            <app-download-progress *ngIf="url !== 'CONTACTE'"></app-download-progress>
            <router-outlet></router-outlet>
        </div>
    </mat-drawer-container>
</div>
